// SPDX-License-Identifier: AGPL-3.0-or-later
// KONVO: names of the parts of Konvo and kinds of note, for the feedback card and Team insights.

import type {FeedbackArea, FeedbackKind} from '@fluxer/schema/src/domains/konvo/AppFeedback';
import type {MessageDescriptor} from '@lingui/core';
import {msg} from '@lingui/core/macro';

export const AREA_LABELS: Record<FeedbackArea, MessageDescriptor> = {
	chats: msg({message: 'Chats', comment: 'Feedback: the part of Konvo a note is about.'}),
	mail: msg({message: 'Mail', comment: 'Feedback: the part of Konvo a note is about.'}),
	calendar: msg({message: 'Calendar', comment: 'Feedback: the part of Konvo a note is about.'}),
	tasks: msg({message: 'Tasks', comment: 'Feedback: the part of Konvo a note is about.'}),
	whatsapp: msg({message: 'WhatsApp', comment: 'Feedback: the part of Konvo a note is about.'}),
	home: msg({message: 'Home', comment: 'Feedback: the part of Konvo a note is about.'}),
	notes: msg({message: 'Notes', comment: 'Feedback: the part of Konvo a note is about.'}),
	calls: msg({message: 'Calls', comment: 'Feedback: the part of Konvo a note is about.'}),
	assistant: msg({message: 'Assistant', comment: 'Feedback: the part of Konvo a note is about.'}),
	phone_app: msg({message: 'Phone app', comment: 'Feedback: the part of Konvo a note is about.'}),
	other: msg({message: 'Something else', comment: 'Feedback: a note about another part of Konvo.'}),
};

export const KIND_LABELS: Record<FeedbackKind, MessageDescriptor> = {
	idea: msg({message: 'Idea', comment: 'Feedback: a feature request or improvement.'}),
	problem: msg({message: 'Problem', comment: 'Feedback: something broken or annoying.'}),
	praise: msg({message: 'Something I like', comment: 'Feedback: praise for something that works well.'}),
};

/** Under the stars: what 1 and 5 mean, and each value's name for screen readers. */
export const RATING_LABELS: ReadonlyArray<MessageDescriptor> = [
	msg({message: 'Not great', comment: 'Feedback card: name of a 1-star rating.'}),
	msg({message: 'Could be better', comment: 'Feedback card: name of a 2-star rating.'}),
	msg({message: 'It’s fine', comment: 'Feedback card: name of a 3-star rating.'}),
	msg({message: 'Really good', comment: 'Feedback card: name of a 4-star rating.'}),
	msg({message: 'Love it', comment: 'Feedback card: name of a 5-star rating.'}),
];
